/* ==========================================================================
   Marka sayfası etkileşimleri (collection.brand)
   --------------------------------------------------------------------------
   Bu dosyanın BİREBİR kopyası iki yerde:
     tema:  assets/brand-page-ui.js      (sections/brand-page.liquid yükler)
     panel: vendor/assets/js/brand-page-ui.js  (brand-pages.php önizlemesi)
   Biri değişirse diğerine kopyalanmalı.

   Olaylar belgeye bir kez bağlanır (delegation); önizleme her çizildiğinde
   yalnız bpUi.init(kök) çağrılır. Slayt otomatik geçişi önizlemede kapalı.
   ========================================================================== */
(function () {
  'use strict';
  if (window.bpUi) return;

  /* ── Vitrin okları: uçta soluklaşma ── */
  function railSync(track) {
    var rail = track.parentNode, max = track.scrollWidth - track.clientWidth - 2;
    var prev = rail.querySelector('[data-bp-rail="-1"]'), next = rail.querySelector('[data-bp-rail="1"]');
    if (prev) prev.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft >= max;
  }

  /* ── Slayt gösterisi ── */
  function ssIndex(track) { return Math.round(track.scrollLeft / Math.max(track.clientWidth, 1)); }
  function ssGo(ss, i) {
    var track = ss.querySelector('.bp-ss__track'), n = track.children.length;
    i = ((i % n) + n) % n;
    track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
  }
  function ssSync(ss) {
    var track = ss.querySelector('.bp-ss__track'), k = ssIndex(track);
    var dots = ss.querySelectorAll('.bp-ss__dot');
    for (var j = 0; j < dots.length; j++) dots[j].classList.toggle('is-on', j === k);
  }
  function ssInit(ss, autoplay) {
    if (ss.bpReady) return;
    ss.bpReady = true;
    var track = ss.querySelector('.bp-ss__track'), dots = ss.querySelector('.bp-ss__dots');
    var n = track.children.length;
    if (n < 2) {
      ss.querySelectorAll('.bp-ss__arrow').forEach(function (a) { a.hidden = true; });
      return;
    }
    var html = '';
    for (var i = 0; i < n; i++) html += '<button type="button" class="bp-ss__dot" aria-label="' + (i + 1) + '. slayt"></button>';
    dots.innerHTML = html;
    var t;
    track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(function () { ssSync(ss); }, 60); });
    ssSync(ss);

    var sec = +ss.getAttribute('data-autoplay') || 0;
    if (!autoplay || !sec) return;
    var paused = false;
    ss.addEventListener('mouseenter', function () { paused = true; });
    ss.addEventListener('mouseleave', function () { paused = false; });
    ss.addEventListener('touchstart', function () { paused = true; }, { passive: true });
    var timer = setInterval(function () {
      if (!ss.isConnected) { clearInterval(timer); return; }
      if (!paused && !document.hidden) ssGo(ss, ssIndex(track) + 1);
    }, sec * 1000);
  }

  /* ── Kombini keşfet: nokta ↔ kayan listedeki kart ──
     Seçilen noktanın kartı vurgulanır ve liste o karta kaydırılır. */
  function hsSelect(hs, i, scroll) {
    var slide = null;
    hs.querySelectorAll('[data-hs]').forEach(function (el) {
      var on = i !== '' && el.getAttribute('data-hs') === i;
      el.classList.toggle('is-on', on);
      if (on && el.classList.contains('bp-hs__slide')) slide = el;
    });
    if (slide && scroll) {
      var track = slide.parentNode;
      track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });   // track konum referansı (CSS: position: relative)
    }
  }

  /* ── Kayan yazı ──
     HTML'de metin bir kez gelir (arama motoru aynı cümleyi tekrar tekrar
     görmesin). Şeridi dolduran üç tekrar ve kesintisiz dönüş için özdeş ikinci
     grup (animasyon %50 kayıp başa sarar) burada üretilir. */
  function mqInit(track) {
    if (track.bpReady) return;
    track.bpReady = true;
    var groups = track.querySelectorAll('.bp-mq__group');
    if (groups.length !== 1) return;   // eski işaretleme: zaten dolu
    var g = groups[0], one = g.innerHTML;
    g.innerHTML = one + one + one;
    var copy = g.cloneNode(true);
    copy.setAttribute('aria-hidden', 'true');
    track.appendChild(copy);
  }

  /* ── Belge düzeyi olaylar (bir kez) ── */
  document.addEventListener('click', function (e) {
    var t = e.target;

    var rail = t.closest('[data-bp-rail]');
    if (rail) {
      var track = rail.parentNode.querySelector('.bp-sc__track');
      track.scrollBy({ left: +rail.getAttribute('data-bp-rail') * track.clientWidth * 0.9, behavior: 'smooth' });
      return;
    }

    var ssBtn = t.closest('.bp-ss__arrow, .bp-ss__dot');
    if (ssBtn) {
      var ss = ssBtn.closest('.bp-ss'), tr = ss.querySelector('.bp-ss__track');
      if (ssBtn.classList.contains('bp-ss__arrow')) ssGo(ss, ssIndex(tr) + (+ssBtn.getAttribute('data-dir')));
      else ssGo(ss, Array.prototype.indexOf.call(ssBtn.parentNode.children, ssBtn));
      return;
    }

    var tab = t.closest('.bp-tabs__btn');
    if (tab) {
      var root = tab.closest('.bp-tabs'), key = tab.getAttribute('data-tab');
      root.querySelectorAll('.bp-tabs__btn').forEach(function (b) {
        var on = b === tab;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      root.querySelectorAll('.bp-tabs__panel').forEach(function (p) { p.hidden = p.getAttribute('data-tab') !== key; });
      return;
    }

    var pin = t.closest('.bp-hs__pin');
    if (pin) {
      var hs = pin.closest('.bp-hs'), i = pin.getAttribute('data-hs');
      hsSelect(hs, pin.classList.contains('is-on') ? '' : i, true);
    }
  });

  // Kayan listede kartın üstüne gelince görseldeki noktası vurgulanır (liste kaydırılmaz).
  document.addEventListener('mouseover', function (e) {
    var slide = e.target.closest && e.target.closest('.bp-hs__slide');
    if (!slide) return;
    hsSelect(slide.closest('.bp-hs'), slide.getAttribute('data-hs'), false);
  });

  // Önce / sonra kaydırıcısı.
  document.addEventListener('input', function (e) {
    if (e.target.classList && e.target.classList.contains('bp-ba__range')) {
      e.target.parentNode.style.setProperty('--pos', e.target.value + '%');
    }
  });

  document.addEventListener('scroll', function (e) {
    if (e.target.classList && e.target.classList.contains('bp-sc__track')) railSync(e.target);
  }, true);

  function init(root, opts) {
    root = root || document;
    opts = opts || {};
    root.querySelectorAll('.bp-sc__track').forEach(railSync);
    root.querySelectorAll('.bp-mq__track').forEach(mqInit);
    root.querySelectorAll('.bp-ss').forEach(function (ss) { ssInit(ss, opts.autoplay !== false); });
  }

  window.bpUi = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  window.addEventListener('load', function () { init(); });
  window.addEventListener('resize', function () { document.querySelectorAll('.bp-sc__track').forEach(railSync); });
})();
